import PluginAction from '../plugin-action';

/**
 * Action for printing a checklist.
 *
 * @author Reinhard Führicht <rf@typoheads.at>
 */
export default class PrintAction extends PluginAction {
    constructor(container: HTMLElement) {
        super(container);

        const form = this.container.querySelector<HTMLFormElement>('#settings');
        if (form) {
            const typeField = form.querySelector<HTMLInputElement>('input[name="type"]');
            const pdfButton = this.container.querySelector<HTMLButtonElement>('.btn-pdf');

            if (typeField && pdfButton) {
                pdfButton.addEventListener('click', () => {
                    if (!typeField.dataset.pdfType || !typeField.dataset.printType) {
                        return;
                    }

                    // Adjust form to download a PDF directly
                    form.target = '_self';
                    typeField.value = typeField.dataset.pdfType;
                    form.submit();

                    // Reset to defaults
                    typeField.value = typeField.dataset.printType;
                    form.target = '_blank';
                });
            }

            // Initialize hiding/showing certain sections from the print view
            form.querySelectorAll<HTMLInputElement>('.form-check-input').forEach((checkbox: HTMLInputElement) => {
                this.toggleVisibility(checkbox);
                checkbox.addEventListener('change', () => {
                    this.toggleVisibility(checkbox);
                });
            });
        }

        PrintAction.emitter.emit('ready', this);
    }

    /**
     * Hides or shows specific sections in the print view.
     *
     * @param {HTMLInputElement} checkbox
     */
    private toggleVisibility(checkbox: HTMLInputElement): void {
        const id = checkbox.id;
        let elements: NodeListOf<HTMLElement> | null = null;

        switch (id) {
            case 'show-success':
                elements = this.container.querySelectorAll<HTMLElement>('.print-step[data-success="1"]');
                break;
            case 'show-empty':
                elements = this.container.querySelectorAll<HTMLElement>('.print-step[data-empty="1"]');
                break;
            case 'show-error':
                elements = this.container.querySelectorAll<HTMLElement>('.print-step[data-error="1"]');
                break;
            case 'show-notes':
                elements = this.container.querySelectorAll<HTMLElement>('.row[data-row-type="notes"]');
                break;
        }

        if (elements) {
            if (checkbox.checked) {
                elements.forEach(function (element) {
                    element.classList.remove('d-none');
                });
            } else {
                elements.forEach(function (element) {
                    element.classList.add('d-none');
                });
            }
        }
    }
}
